import React from 'react'
import Modal from 'react-modal'
import renderHTML from 'react-render-html'

import '../../../styles/css/components/room/bk-flow-virtual-tour.css'

const BkFlowRoomCardVirtualTour = props => {
	const {
		hotelLabels,
		virtualTourSrc,
		virtualTourExpanded,
		virtualTourEvent
	} = props

	return (
		<Modal
			className={{
				base: 'u-modal u-modal--lg',
				afterOpen: 'u-modal--visible',
				beforeClose: 'u-modal--close',
				ariaHideApp: false
			}}
			overlayClassName={{
				base: 'u-fade',
				afterOpen: 'u-fade--visible',
				beforeClose: 'u-fade--visible'
			}}
			isOpen={ virtualTourExpanded }
			onRequestClose={ virtualTourEvent }
			contentLabel="Virtual Tour Modal"
			shouldCloseOnOverlayClick={ true }
			ariaHideApp={ false }
		>
			<div className="bk-flow-room__virtual-tour">
				<div className="u-modal__header">
					<h5>{ hotelLabels.virtualTour ? hotelLabels.virtualTour : '360 Tour' }</h5>
					<div
						className="u-modal__close u-font-small u-font-bold"
						onClick={virtualTourEvent}
					>
						{ hotelLabels.close ? hotelLabels.close : 'Close'}
						<i className="material-icons">close</i>
					</div>
				</div>

				<div className="u-modal__body">
					{ renderHTML(virtualTourSrc) }
				</div>
			</div>
		</Modal>
	)
}


export default BkFlowRoomCardVirtualTour


// WEBPACK FOOTER //
// ./src/components/room/elements/BkFlowRoomCardVirtualTour.js